import { SortDirection } from 'respona_api/generated/common_pb';
import { OrderBacklinkSortProto } from 'respona_api/generated/order-concierge_pb';
import { BacklinksSortType } from '@ts/orders.types';

// "No sort" for the Placements list: the server keeps its historical newest-created-first
// ordering and ignores the direction. Sending this is byte-identical to a pre-sort client.
export const DEFAULT_BACKLINKS_SORT: BacklinksSortType = {
  field: OrderBacklinkSortProto.ORDER_BACKLINK_SORT_DEFAULT,
  direction: SortDirection.ASC,
};
